export const solutions = [{
    title:"PIM Solution",
    description:"Source-to-pay is a process that starts with finding ,negotiating with and contracting the supplier of goods, and culminates in final payment for those goods.",
    btn_text:"Install",
    id:3000
},
{
    title:"Source to Pay",
    description:"Source-to-pay is a process that starts with finding ,negotiating with and contracting the supplier of goods, and culminates in final payment for those goods.",
    btn_text:"Install",
    id:31245
}]